// Identity Colors - Colori distintivi per ogni identità
// Colori compatibili con tema scuro, ben distinguibili tra loro

const IDENTITY_COLORS = [
  { name: 'purple', bg: 'bg-purple-600/20', border: 'border-purple-500/50', text: 'text-purple-400', accent: '#a855f7' },
  { name: 'cyan', bg: 'bg-cyan-600/20', border: 'border-cyan-500/50', text: 'text-cyan-400', accent: '#06b6d4' },
  { name: 'amber', bg: 'bg-amber-600/20', border: 'border-amber-500/50', text: 'text-amber-400', accent: '#f59e0b' },
  { name: 'emerald', bg: 'bg-emerald-600/20', border: 'border-emerald-500/50', text: 'text-emerald-400', accent: '#10b981' },
  { name: 'rose', bg: 'bg-rose-600/20', border: 'border-rose-500/50', text: 'text-rose-400', accent: '#f43f5e' },
  { name: 'blue', bg: 'bg-blue-600/20', border: 'border-blue-500/50', text: 'text-blue-400', accent: '#3b82f6' },
  { name: 'orange', bg: 'bg-orange-600/20', border: 'border-orange-500/50', text: 'text-orange-400', accent: '#f97316' },
  { name: 'teal', bg: 'bg-teal-600/20', border: 'border-teal-500/50', text: 'text-teal-400', accent: '#14b8a6' },
  { name: 'pink', bg: 'bg-pink-600/20', border: 'border-pink-500/50', text: 'text-pink-400', accent: '#ec4899' },
  { name: 'indigo', bg: 'bg-indigo-600/20', border: 'border-indigo-500/50', text: 'text-indigo-400', accent: '#6366f1' },
];

// Store used colors per identity - persiste nella sessione
const identityColorCache = new Map();

export const getIdentityColor = (identityName) => {
  if (!identityName) return IDENTITY_COLORS[0];
  
  // Return cached color if exists
  if (identityColorCache.has(identityName)) {
    return identityColorCache.get(identityName);
  }
  
  // Generate consistent index from identity name (hash-based)
  let hash = 0;
  for (let i = 0; i < identityName.length; i++) {
    const char = identityName.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  const colorIndex = Math.abs(hash) % IDENTITY_COLORS.length;
  const color = IDENTITY_COLORS[colorIndex];
  
  identityColorCache.set(identityName, color);
  return color;
};

export const IdentityColorBadge = ({ identityName, className = '' }) => {
  const color = getIdentityColor(identityName);
  return (
    <span 
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${color.bg} ${color.text} border ${color.border} ${className}`}
    >
      {identityName}
    </span>
  );
};

export const IdentityColorDot = ({ identityName, size = 8, className = '' }) => {
  const color = getIdentityColor(identityName);
  return (
    <span 
      className={`inline-block rounded-full ${className}`}
      style={{ width: size, height: size, backgroundColor: color.accent }}
    />
  );
};
